import styled from 'styled-components';

export const BottomSpace = styled.div`
  margin-bottom: 2em;
`;

export const RefundContainer = styled.div`
  width: 80%;
  background: ${(props) =>
    props.cancel ? '#fef7d966' : 'rgb(164 226 237 / 8%)'};
  padding: 2em 4em;
  margin: 4em auto;
  border-radius: 18px;
  font-display: optional;

  @media (max-width: 720px) {
    width: 100%;
    padding: 2em;
    margin: ${(props) => (props.margin ? props.margin : '2em auto')};
  }
`;

export const Title = styled.h3`
  font-size: ${(props) => (props.refundhelp ? '22px' : '26px')};
  font-weight: 600;
  padding: ${(props) => props.padding};
  color: ${(props) => props.refundcolor};
  min-height: ${(props) => (props.partnerWithUs ? '31.11px' : 'auto')};
`;

export const RefundContent = styled.p`
  padding: 16px 0 0;
  min-height: ${(props) =>
    props.atMylo
      ? '94.22px'
      : props.weAreLooking
        ? '55.11px'
        : props.myloRefund
          ? '54.4px'
          : 'auto'};

  @media (max-width: 720px) {
    min-height: ${(props) =>
      props.atMylo
        ? '270px'
        : props.weAreLooking
          ? '112px'
          : props.myloRefund
            ? '131.2px'
            : 'auto'};
  }
`;

export const Doubts = styled.h4`
  font-size: 18px;
  font-weight: 500;
  padding: 24px 0 0;
  min-height: ${(props) => (props.whatProducts ? '46.4px' : 'auto')};

  @media (max-width: 720px) {
    min-height: ${(props) => (props.whatProducts ? '68.8px' : 'auto')};
  }
`;
export const ContactRefund = styled.h1`
  font-size: calc(1.3em + 1vw);
  font-weight: 600;
`;
